import { apiFetch } from "../client"

export function listTargets(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/targets${query}`)
}

export function getTarget(targetId: string) {
  return apiFetch<any>(`/targets/${targetId}`)
}

export function createTarget(payload: object) {
  return apiFetch<any>("/targets", {
    method: "POST",
    rawBody: payload,
  })
}

export function updateTarget(targetId: string, payload: object) {
  return apiFetch<any>(`/targets/${targetId}`, {
    method: "PATCH",
    rawBody: payload,
  })
}
